// extracted by mini-css-extract-plugin
export default {"tabIcon":"gc_tabIcon__SlEGT"};